// Components.
import AdminTrail from "./AdminTrail";

// Types.
import IntegrationType from "../../types/integration/IntegrationType";

// Helpers.
import {
    findProfile,
    NOTIFICATION_INTEGRATIONS,
    NotificationIntegrationKind
} from "../../helpers/notificationIntegrations";

type IntegrationTrailProps = {
    // Label for the integration crumb, e.g. "Email".
    section: string
    // Route the integration crumb links back to, e.g. "/admin/integrations/email".
    sectionPath: string
    // Resolves the id in the URL to the name of the record being acted on.
    resolveEntityLabel?: (id: string) => string | undefined
}

// Trail for a single integration, sitting under the Integrations list.
const IntegrationTrail = ({ section, sectionPath, resolveEntityLabel }: IntegrationTrailProps) => (
    <AdminTrail section={section} sectionPath={sectionPath}
                parent={{ label: 'Integrations', to: '/admin/integrations' }}
                resolveEntityLabel={resolveEntityLabel}/>
);

// Resolver for the notification integrations, whose URL id is a parameter prefix
// (e.g. "mail.smtp2") identifying one of several configured profiles.
export const resolveProfileLabel = (kind: NotificationIntegrationKind, parameters: IntegrationType[]) =>
    (id: string) => findProfile(parameters, NOTIFICATION_INTEGRATIONS[kind], id)?.label;

export default IntegrationTrail;
